import React from 'react';
import { TypographyH2, TypographyP } from '@/Components/shadcn';
import UIStrings from '@/Utils/UIStrings';
import LoadingTab from '../LoadingTab';
import { useEmailIntegrationStatus } from './api/useOAuthEmailIntegration';
import EmailIntegrationStatus from './EmailIntegrations/IntegrationStatus/EmailIntegrationStatus';
import EmailIntegrationProviders from './EmailIntegrations/IntegrationProviders/EmailIntegrationProviders';

const IntegrationsTab = () => {
    const { data, isLoading, error } = useEmailIntegrationStatus();

    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-2">
                <TypographyH2>{UIStrings.EmailIntegration}</TypographyH2>
                <TypographyP>{UIStrings.ConnectYourWorkEmailAccountToEmailAndManage}</TypographyP>
            </div>
            <LoadingTab isLoading={isLoading} loadingFailed={!!error}>
                {data ? <EmailIntegrationStatus /> : <EmailIntegrationProviders />}
            </LoadingTab>
        </div>
    );
};

export default IntegrationsTab;
